import {
  DEFAULT_FONT_SIZES,
  DEFAULT_LINE_HEIGHT,
  DEFAULT_LINE_HEIGHT_OPTIONS,
} from 'components/editor/grid/reduxStore/defaultTextDefaultValue';
import type { AllTextDefaultStylesType } from 'components/editor/grid/reduxStore/textDefaultStylingSlice';
import { useAllAvailableFonts } from 'hooks/useAllAvailableFonts';
import { useAppSelector } from 'components/editor/grid/reduxStore/Store';
import { selectContentId } from 'components/editor/grid/reduxStore/documentSettingsSlice';
import { useMemo } from 'react';

export const getLineHeightDisplayName = (level: AllTextDefaultStylesType['lineHeight']): string =>
  DEFAULT_LINE_HEIGHT_OPTIONS.find((o) => o.level === String(level))?.name ??
  DEFAULT_LINE_HEIGHT_OPTIONS.find((o) => o.level === DEFAULT_LINE_HEIGHT)?.name ??
  'Default';

export function useFormatStyleFieldOptions() {
  const contentId = useAppSelector(selectContentId);

  const fontSizeOptions = DEFAULT_FONT_SIZES.map((option) => option.name);
  const lineHeightMenuItems = DEFAULT_LINE_HEIGHT_OPTIONS.map(({ name }) => name);
  const lineHeightMenuItemsVal = Object.fromEntries(DEFAULT_LINE_HEIGHT_OPTIONS.map(({ name, level }) => [name, level]));
  const allAvailableFontObjects = useAllAvailableFonts(contentId);
  const allAvailableFonts = useMemo(() => allAvailableFontObjects.map((f) => f.name), [allAvailableFontObjects]);

  return {
    fontSizeOptions,
    lineHeightMenuItems,
    lineHeightMenuItemsVal,
    allAvailableFonts,
    getLineHeightDisplayName,
  };
}
